(function () {
  const SCROLL_UP_HIDE_THRESHOLD = 150;
  const stickyAtc = document.querySelector('.td-sticky-atc');
  const submitButton = document.querySelector('.product .product-form__submit');
  const stickySubmitButton = stickyAtc?.querySelector('.td-sticky-atc__submit');
  const variantToggleButton = stickyAtc?.querySelector('[data-sticky-atc-variant-toggle]');
  const variantSelectionId = variantToggleButton?.getAttribute('aria-controls');
  const variantSelection = variantSelectionId
    ? document.getElementById(variantSelectionId)
    : stickyAtc?.querySelector('.variant-selection');

  if (!submitButton || !stickyAtc) return;

  let lastScrollY = window.scrollY;
  let upScrollDistance = 0;


  function setStickyAtcVisible(isVisible) {
    stickyAtc.classList.toggle('td-sticky-atc--visible', isVisible);
  }

  function updateStickyAtcVisibility() {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;
    const isAboveViewportTop = submitButton.getBoundingClientRect().top < 0;

    if (!isAboveViewportTop) {
      upScrollDistance = 0;
      setStickyAtcVisible(false);
    } else if (scrollDelta > 0) {
      upScrollDistance = 0;
      setStickyAtcVisible(true);
    } else if (scrollDelta < 0) {
      upScrollDistance += -scrollDelta;
      if (upScrollDistance >= SCROLL_UP_HIDE_THRESHOLD) {
        setStickyAtcVisible(false);
      }
    }

    lastScrollY = currentScrollY;
  }

  function getMainProductForm() {
    return (
      document.querySelector('product-info product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('.product product-form form')
    );
  }

  function syncStickySubmitState() {
    if (!stickySubmitButton) return;

    stickySubmitButton.disabled = submitButton.disabled;
    if (submitButton.getAttribute('aria-disabled') === 'true') {
      stickySubmitButton.setAttribute('aria-disabled', 'true');
    } else {
      stickySubmitButton.removeAttribute('aria-disabled');
    }
  }

  function handleStickySubmitClick(event) {
    event.preventDefault();

    if (stickySubmitButton.disabled || stickySubmitButton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });

    const form = getMainProductForm();
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function isVariantSelectionVisible() {
    return Boolean(variantSelection?.classList.contains('variant-selection--visible'));
  }

  function setVariantSelectionVisible(isVisible) {
    if (!variantSelection) return;

    variantToggleButton?.setAttribute('aria-expanded', String(isVisible));

    if (isVisible) {
      variantSelection.hidden = false;
      requestAnimationFrame(() => {
        variantSelection.classList.add('variant-selection--visible');
      });
      return;
    }

    variantSelection.classList.remove('variant-selection--visible');
    variantSelection.hidden = true;
  }

  function toggleVariantSelection() {
    if (!variantSelection) return;
    setVariantSelectionVisible(!isVariantSelectionVisible());
  }

  function handleDocumentClick(event) {
    if (!isVariantSelectionVisible()) return;
    if (stickyAtc.contains(event.target)) return;

    setVariantSelectionVisible(false);
  }

  if (stickySubmitButton) {
    stickySubmitButton.addEventListener('click', handleStickySubmitClick);
    syncStickySubmitState();

    const submitStateObserver = new MutationObserver(syncStickySubmitState);
    submitStateObserver.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
  }

  if (variantToggleButton && variantSelection) {
    variantToggleButton.addEventListener('click', toggleVariantSelection);

    stickyAtc.querySelectorAll('[data-sticky-atc-variant-close]').forEach((closeTrigger) => {
      closeTrigger.addEventListener('click', () => setVariantSelectionVisible(false));
    });

    document.addEventListener('click', handleDocumentClick);
  }

  window.addEventListener('scroll', updateStickyAtcVisibility, { passive: true });
  setStickyAtcVisible(submitButton.getBoundingClientRect().top < 0);
})();
